// extracted by mini-css-extract-plugin
export default {"link":"DuoMenu_link__CGy2s","menu":"DuoMenu_menu__au5Dz","circles":"DuoMenu_circles__oTLDA","circleTop":"DuoMenu_circleTop__pE1+V","circle1":"DuoMenu_circle1__GG-tM"};